module.exports = __webpack_public_path__ + "static/media/YB5M06_5.b6c4a28f.jpg";